import { c as _c } from "react/compiler-runtime";
import { Checkbox, Modal, toast } from '@systemeio/ui';
import { ConnectInfoIntegration } from 'modules/profile/integrations/components/connect-info-integration';
import { ItemIntegration } from 'modules/profile/integrations/components/item-integration';
import { WrapperIntegration } from 'modules/profile/integrations/components/wrapper-integration';
import { WrapperIntegrationSkeleton } from 'modules/profile/integrations/components/wrapper-integtation-skeleton';
import { getHelpPageLinkZoom } from 'modules/profile/integrations/utils/get-help-page-link-zoom';
import { useIntegration } from 'modules/profile/integrations/zoom/hook/use-integration';
import { useIntegrations } from 'modules/profile/integrations/zoom/hook/use-integrations';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { ZoomIntegrationIcon } from '@systemeio/ui/icons';
export const ZoomIntegrationComingSoon = () => {
  const $ = _c(8);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ZoomIntegrationIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.user_settings.integrations_page.zoom_integration.name");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.user_settings.integrations_page.zoom_integration.subtitle");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <WrapperIntegration icon={t0} title={t1} subTitle={t2} isComingSoon={true} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export const ZoomIntegration = () => {
  const $ = _c(21);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disassociateEvents, setDisassociateEvents] = useState(true);
  const {
    openZoomLogin,
    removeIntegration
  } = useIntegration({
    onError: handleIntegrationError,
    onSuccess: handleIntegrationSuccess,
    setIsLoading
  });
  const {
    data,
    mutate
  } = useIntegrations();
  async function handleIntegrationSuccess() {
    await mutate();
  }
  let t0;
  if ($[0] !== disassociateEvents || $[1] !== mutate || $[2] !== removeIntegration) {
    t0 = async function handleIntegrationRemove() {
      ;
      try {
        setIsLoading(true);
        await removeIntegration(disassociateEvents);
        await mutate();
        setIsLoading(false);
        setOpened(false);
      } catch (t1) {
        const e = t1;
        throw e;
      }
    };
    $[0] = disassociateEvents;
    $[1] = mutate;
    $[2] = removeIntegration;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleIntegrationRemove = t0;
  function handleIntegrationError(error) {
    toast.error(error.message);
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleOpenModal() {
      setOpened(true);
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleOpenModal = t1;
  let t2;
  if ($[5] !== openZoomLogin) {
    t2 = async function handleOpenZoomLogin() {
      await openZoomLogin();
      setOpened(false);
    };
    $[5] = openZoomLogin;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleOpenZoomLogin = t2;
  let t3;
  if ($[7] !== handleIntegrationRemove) {
    t3 = async function handleRemoveZoomIntegration() {
      await handleIntegrationRemove();
      setOpened(false);
    };
    $[7] = handleIntegrationRemove;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleRemoveZoomIntegration = t3;
  let t4;
  if ($[9] !== data || $[10] !== disassociateEvents || $[11] !== handleOpenZoomLogin || $[12] !== handleRemoveZoomIntegration || $[13] !== isLoading || $[14] !== opened || $[15] !== t || $[16] !== user?.dashboardLocale || $[17] !== user?.dateFormat || $[18] !== user?.timeFormat || $[19] !== user?.timezone) {
    t4 = <>{data ? <><WrapperIntegration icon={<ZoomIntegrationIcon />} title={t("dashboard.user_settings.integrations_page.zoom_integration.name")} subTitle={t("dashboard.user_settings.integrations_page.zoom_integration.subtitle")} onClick={handleOpenModal} isConnect={data.items.length !== 0} /><Modal title={t("dashboard.user_settings.integrations_page.zoom_integration_title")} onClose={() => setOpened(false)} opened={opened} isFetching={isLoading}><>{data.items.length !== 0 ? data.items.map(item => <ItemIntegration key={item.id} email={item.email} status={item.status && t("global.active")} createdAt={dateTimeFormat(item.createdAt, {
              timeFormat: user?.timeFormat,
              dateFormat: user?.dateFormat,
              timeZone: user?.timezone
            })} removeIntegration={handleRemoveZoomIntegration} additionalContent={<Checkbox value={disassociateEvents} onChange={setDisassociateEvents} label={t("dashboard.user_settings.integrations_page.zoom_integration.remove_events")} />} />) : <ConnectInfoIntegration isFetching={isLoading} href={getHelpPageLinkZoom(user?.dashboardLocale)} handleOpenIntegrationLogin={handleOpenZoomLogin} infoText="dashboard.user_settings.integrations_page.zoom_integration_help" />}</></Modal></> : <WrapperIntegrationSkeleton />}</>;
    $[9] = data;
    $[10] = disassociateEvents;
    $[11] = handleOpenZoomLogin;
    $[12] = handleRemoveZoomIntegration;
    $[13] = isLoading;
    $[14] = opened;
    $[15] = t;
    $[16] = user?.dashboardLocale;
    $[17] = user?.dateFormat;
    $[18] = user?.timeFormat;
    $[19] = user?.timezone;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
};